'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.retryWithBackoff = retryWithBackoff;
exports.checkStatus = checkStatus;
exports.mapResponse = mapResponse;

var _Observable = require('rxjs/Observable');

require('rxjs/add/operator/map');

require('rxjs/add/operator/mergeMap');

require('rxjs/add/operator/retryWhen');

require('rxjs/add/operator/scan');

require('rxjs/add/observable/timer');

require('rxjs/add/operator/startWith');

require('rxjs/add/operator/catch');

require('rxjs/add/operator/takeUntil');

function retryWithBackoff() {
  var retries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
  var backoff = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (count) {
    return Math.pow(2, count) * 1000;
  };
  var excludedStatusCodes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [403, 404];

  return this.retryWhen(function (errors) {
    return errors.scan(function (count, error) {
      if (count >= retries || excludedStatusCodes.find(function (statusCode) {
        return statusCode === error.status;
      })) {
        throw error;
      }
      return count + 1;
    }, 0).mergeMap(function (count) {
      return _Observable.Observable.timer(backoff(count));
    });
  });
}

function checkStatus() {
  var ceiling = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;

  return this.map(function (data) {
    if (data.status >= 200 && data.status < ceiling) {
      return data;
    }

    throw data;
  });
}

function mapResponse(func) {
  return this.map(function (data) {
    return func(data.response);
  });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@drifthq/dapper/lib/rx/utils.js
// module id = 599
// module chunks = 0